import PaymentKioskAppWrapper from './PaymentKioskAppWrapper.jsx';

export default PaymentKioskAppWrapper;


// WEBPACK FOOTER //
// ./src/components/PaymentKioskAppWrapper/index.js